export enum HHDSTileGridColumns {    
    Three = 3,
    Four = 4
}